import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { DocumentWrapper } from '../../../components/DocumentWrapper/DocumentWrapper'
import document from './UserAgreement.md'

export const UserAgreementPage: FC = () => {
    const navigate = useNavigate()

    const handleBack = () => {
        navigate(-1)
    }

    const handleDownloadDocument = () => {
        window.open('/user-agreement.pdf')
    }

    return (
        <DocumentWrapper
            title="Пользовательское соглашение"
            onBack={handleBack}
            onDownload={handleDownloadDocument}
            document={document}
        />
    )
}
